import { Container, Button, Select, InputLabel, FormControl, Modal, Box, Tooltip, MenuItem, TextField, Typography, AppBar, Toolbar, Paper } from '@mui/material';
import React, { useState, useEffect } from 'react';
import LoadingBar from 'react-top-loading-bar';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddNationality = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success'); // 'success' or 'error'
  let navigate = useNavigate();
  const [countryData, setCountryData] = useState([]);
  const [nationality, setNationality] = useState('');
  const [countryId, setCountryId] = useState('');
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);

  const fetchCountryData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Country/GetCountry`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const responseData = await response.json();
        setCountryData(responseData);
        setLoadingBarProgress(100);
      } else {
        console.error('Error fetching country data');
        // alert('Failed to fetch country data');
        setSnackbarMessage('Failed to fetch country data');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");

        setLoadingBarProgress(0);
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred while fetching country data. Please try again later.');
      setSnackbarMessage('An error occurred while fetching country data. Please try again later.');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
    }
  };

  useEffect(() => {
    fetchCountryData();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/Nationality`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          "nationality": nationality,
          "nationalityId": countryId,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        // Handle successful save, e.g., show a success message
        setLoadingBarProgress(100);
        
        // Check the status field in the response or error keywords in message
        const errorKeywords = ['already exist', 'failed', 'error', 'unable', 'cannot'];
        const messageHasError = errorKeywords.some(keyword => 
          responseData.msg && responseData.msg.toLowerCase().includes(keyword)
        );
        
        if (responseData.status && responseData.status.toLowerCase().includes('failed')) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else if (messageHasError) {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else {
          setModalType('success');
          setModalMessage(responseData.msg || 'Nationality Added Successfully');
        }
        
        setModalOpen(true);
        if (!messageHasError && (!responseData.status || !responseData.status.toLowerCase().includes('failed'))) {
          setNationality('');
          setCountryId('');
        }
      } else {
        setLoadingBarProgress(0);
        const responseData = await response.json();
        setModalType('error');
        setModalMessage(responseData.msg || 'Failed to add nationality');
        setModalOpen(true);
      }
    } catch (error) {
      console.error('API request error:', error);
      setLoadingBarProgress(0);
      setModalType('error');
      setModalMessage('An error occurred. Please try again later.');
      setModalOpen(true);
    }
  };

  const handleCancel = () => {
    setNationality('');
    setCountryId('');
  };

  return (
    // <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
    <Container mt={4}>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Add Nationality
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} sx={{ padding: 2, width: '100%', margin: 'auto', marginTop: 1 }}>
        <FormControl fullWidth sx={{ marginBottom: 3 }}>
          <InputLabel id="countryName-label">Country Name</InputLabel>
          <Select
            labelId="countryName-label"
            id="countryName"
            value={countryId}
            label="Country Name"
            onChange={(e) => setCountryId(e.target.value)}
          >
            <MenuItem value="" disabled>Select Country</MenuItem>
            {countryData.map((country) => (
              <MenuItem key={country.countryId} value={country.countryId}>
                {country.countryName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          label="Nationality"
          id="nationality"
          sx={{ marginBottom: 3 }}
          value={nationality}
          onChange={(e) => setNationality(e.target.value)}
        />
        <Tooltip title={!countryId && "Select a Country" || !nationality && "Enter Nationality"} arrow>
          <span>
            <Button
              variant="contained"
              color="primary"
              disabled={!countryId || !nationality}
              onClick={handleSave}
              sx={{ marginRight: 2 }}
            >
              SAVE
            </Button>
          </span>
        </Tooltip>
        <Button variant="contained" color="error" onClick={handleCancel}>
          RESET
        </Button>
      </Paper>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ 
            backgroundColor: modalType === 'success' ? '#0B1F40' : '#d32f2f', 
            padding: '12px 16px' 
          }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'success' ? 'Success ✅' : 'Error ❌'}
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType === 'success') {
                    navigate(-1);
                  }
                }}
                variant="contained"
                color={modalType === 'success' ? 'primary' : 'error'}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      {/* Snackbar removed - using modal instead */}
    </Container>

  );
};

export default AddNationality;
